import type { ProgressProps as _ProgressProps } from "@chakra-ui/react";
import { Progress as _Progress } from "@chakra-ui/react";

export interface ProgressProps extends _ProgressProps {}

export const Progress = ({ ...props }: ProgressProps) => <_Progress {...props} />;
